"use strict";
const winston = require('winston');
const isObject = require('lodash/isObject');
const isEmpty = require('lodash/isEmpty');
const { asyncLocalStorage } = require('./tracerService');
const { isDevelopment } = require('../auth/consts');
const isLocalLog = process.env.IS_LOCAL_LOG;
const writeLocalLogToFile = process.env.WRITE_LOCAL_LOG_TO_FILE;
const logLevel = process.env.LOG_LEVEL || 'verbose';
const isSilent = process.env.IS_LOG_SILENT;
const { combine, timestamp, colorize, printf, splat, json, simple } = winston.format;
/**
 * log levels
    error: 0,
    warn: 1,
    info: 2,
    http: 3,
    verbose: 4,
    debug: 5,
    silly: 6
 */
const logger = winston.createLogger({
    // only catch info, warn, error
    level: logLevel,
    format: combine(timestamp(), json()),
    transports: [],
    silent: isSilent,
});
const consoleTransport = new winston.transports.Console({ format: winston.format.combine(splat(), json()),
    level: logLevel });
const logMessage = (msg) => {
    const { level, timestamp: ts, message, traceId, ...restProps } = msg;
    return `${ts} - ${level}: ${message}. ${traceId ? `traceId: ${traceId}.` : ''} properties: ${JSON.stringify(restProps)}`;
};
const consoleTransportColors = new winston.transports.Console({ colorize: true,
    format: winston.format.combine(timestamp(), simple(), printf((msg) => colorize().colorize(msg.level, logMessage(msg)))),
    level: logLevel });
if (isLocalLog) {
    if (writeLocalLogToFile) {
        const localFileWriterTransport = new winston.transports.File({ filename: `logs/local_log_${new Date().toISOString()}.log` });
        logger.add(localFileWriterTransport);
    }
    else {
        logger.add(consoleTransportColors);
    }
}
else {
    logger.add(consoleTransport);
}
const updateJsonProps = (data) => {
    const { token, password, serviceId, service_id: sId, accountId, ...rest } = data;
    const store = asyncLocalStorage ? asyncLocalStorage.getStore() : null;
    const traceId = store ? store.get('traceId') : '';
    const originalEndpoint = store ? store.get('originalEndpoint') : '';
    const authUserId = store ? store.get('authUserId') : '';
    const serviceIdContext = store ? store.get('serviceId') : '';
    return {
        ...rest,
        ...store ? { traceId, originalEndpoint, authUserId } : {},
        serviceId: serviceId || sId || serviceIdContext,
        // rename to t_accountId for avoiding conflict with newrelic accountId - https://docs.newrelic.com/docs/logs/log-api/introduction-log-api/
        t_accountId: accountId,
    };
};
const enumerateObject = (k, value) => {
    if (value instanceof Object) {
        const obj = {};
        Object.getOwnPropertyNames(value).forEach((key) => {
            obj[key] = value[key];
        });
        return obj;
    }
    return value;
};
const totangoLog = {
    info: (message, loggerData = {}, additionalData = {}) => {
        logger.info(message, updateJsonProps({ ...loggerData, ...additionalData }));
    },
    /**
     *
     * @param {string} message
     * @param {object} loggerData
     * @param {any} err
     * @param {object} additionalData
     */
    error: (message, loggerData = {}, err = null, additionalData = {}) => {
        let error;
        if (err && err instanceof Error) {
            error = err;
        }
        else if (isObject(err) && !isEmpty(err)) {
            if (err.err instanceof Error) {
                error = err.err;
            }
            else if (err.error instanceof Error) {
                error = err.error;
            }
            else {
                error = new Error(err.message || message);
                error.code = err.code || null;
                Object.keys(err).forEach((property) => {
                    error[property] = err[property];
                });
            }
        }
        else if (typeof err === 'string') {
            error = new Error(err || 'error');
        }
        else if (err === null || err === undefined) {
            error = new Error(message);
        }
        else {
            error = new Error(`Unknown error type: ${typeof err}`);
        }
        const errorMsg = {
            stack: error.stack,
            message: error.message || error._error || error.error || error.response?.statusText,
            code: error.code,
        };
        try {
            if (typeof errorMsg.message === 'object') {
                errorMsg.message = JSON.parse(JSON.stringify(errorMsg.message, enumerateObject));
            }
        }
        catch (e) {
            errorMsg.message = '';
            logger.error('Failed to parse error', e);
        }
        logger.error(message, updateJsonProps({ ...loggerData, ...additionalData, error: errorMsg }));
    },
    debug: (message, loggerData = {}, additionalData = {}) => {
        if (isDevelopment || logLevel === 'debug') {
            logger.info(message, updateJsonProps({ ...loggerData, ...additionalData }));
        }
    },
    verbose: (message, loggerData = {}, additionalData = {}) => {
        logger.verbose(message, updateJsonProps({ ...loggerData, ...additionalData }));
    },
    warn: (message, loggerData = {}, additionalData = {}) => {
        logger.warn(message, updateJsonProps({ ...loggerData, ...additionalData }));
    },
    // morgan logs
    write: (morganMsg) => {
        const values = morganMsg.split(';');
        const reqJson = values.reduce((acc, item) => {
            const dashIdx = item.indexOf('-');
            const [key, val = ''] = [item.slice(0, dashIdx), item.slice(dashIdx + 1)];
            return {
                ...acc,
                [key]: val.trim(),
            };
        }, {});
        logger.info(`${reqJson.method} ${reqJson.url} ${reqJson.status} ${reqJson['response time']} service_id: ${reqJson.serviceId}`, reqJson);
    },
};
module.exports = totangoLog;
//# sourceMappingURL=logService.js.map